import { createSlice } from '@reduxjs/toolkit';
import { setUser } from './userSlice';
import { personReceived } from '../../main/apps/people/store/person';
import People from '../../services/hammurabi/people';
import { initialState as initialUser } from '../../auth/store/userSlice';
import axiosInstance from '../../store/middleware/axiosInstance';

const initialState = {
  success: false,
  error: {
    username: null,
    password: null
  }
};

const loginSlice = createSlice({
  name: 'auth/login',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.success = true;
    },
    logoutSuccess: (state, action) => {
      state = initialState;
    },
    loginError: (state, action) => {
      state.success = false;
      state.error = action.payload;
    }
  },
  extraReducers: {}
});

export const loginUser =
  (user, redirect = null) =>
  (dispatch, getState) => {
    dispatch(loginSuccess());
    dispatch(setUser(user));

    if (redirect) {
      const { history, location } = redirect;
      console.log('redirecting to', location.state.from.pathname);
      history.push(location.state.from.pathname);
    }
  };

export const logoutUser = () => (dispatch, getState) => {
  deleteLoginFromLocalStorage();
  dispatch(logoutSuccess());
};

export const deleteLoginFromLocalStorage = () => {
  if (localStorage.getItem('HammurabiAuth')) {
    localStorage.removeItem('HammurabiAuth');
  }
};

// idToken: the raw Auth0 id token; the backend reads who this is from it (auth_id, email, email_verified)
export const getPersonAndUser = (auth0User, idToken) => async (dispatch, getState) => {
  let campaignId = null;
  try {
    const stored = localStorage.getItem('HammMID');
    campaignId = stored ? atob(stored) : null;
  } catch (e) {}
  try {
    const personData = await People.getPerson(
      {
        // Ignored when the backend verifies Auth0 (VALIDATE_AUTH0=production); the fallback if that is switched off
        email: auth0User.email,
        auth_id: auth0User.sub,
        email_verified: auth0User.email_verified,
        first_name: auth0User.given_name || '',
        last_name: auth0User.family_name || '',
        campaign_id: campaignId
      },
      idToken
    );

    localStorage.setItem(
      'HammurabiAuth',
      JSON.stringify({ fresh: personData.token, refresh: personData.refresh })
    );
    const person = personData.person;

    axiosInstance.defaults.headers.Authorization = `Bearer ${personData?.token}`;

    dispatch(personReceived(person));
    dispatch(loginUser(getUserFromPerson(person)));
  } catch (e) {
    // SB already has this email under another login: it is linked once Auth0 has verified the email
    if (e?.response?.data?.reason === 'email_not_verified') {
      dispatch(
        loginUser({ ...initialUser, email: auth0User.email, auth_id: auth0User.sub, email_verified: false })
      );
    } else {
      console.log(e);
    }
  }
};

const getUserFromPerson = (person) => {
  let userData = {};
  Object.keys(initialUser).forEach((x) => {
    userData[x] = person[x];
  });
  userData.id = person.id;
  return userData;
};

export const { loginSuccess, loginError, logoutSuccess } = loginSlice.actions;

export default loginSlice.reducer;
